import axios from "axios";
import apiClient from ".";
import { UNO_URL } from "../env";

export const getUserDetails = async (token) => {
    let { data } = await axios.get(`${UNO_URL}/api/user/me`, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        }
    });
    return data
}

// import { applicationsCategory, saveEnvironmentTypes } from "../Store/slice/applicationSlice";
// import { saveAllModuleCategory } from "../Store/slice/moduleFilter";
// import { TAG_LIST } from "./apiEndpoints";

// export const getModuleTagCategories = async (dispatch, UNO_URL, id) => {
//     try {
//         let data = await apiClient.get(`${UNO_URL}${TAG_LIST}/${id}`);
//         let filterChildren = data.children.filter(e => e.id != 2);
//         dispatch(saveAllModuleCategory({ data: { ...data, children: filterChildren } }))
//     } catch (error) {

//     }
// }

// export const getApplicationUsingTagCategory = async (dispatch, UNO_URL, id, token) => {
//     try {
//         const { data } = await axios.get(`${UNO_URL}${TAG_LIST}/${id}`, {
//             headers: { Authorization: `Bearer ${token}` },
//         });
//         dispatch(applicationsCategory({ data: data.data }));
//     } catch (error) {
//         console.error(error);
//     }
// };

// export const getEnvironmentTagCategories = async (dispatch, UNO_URL, id) => {
//     try {
//         let data = await apiClient.get(`${UNO_URL}${TAG_LIST}/${id}`);
//         dispatch(saveEnvironmentTypes({ data: { ...data } }))
//     } catch (error) {

//     }
// }

export const fetchInitialAppData = async (dispatch, token) => {
    // getModuleTagCategories(dispatch, UNO_URL, moduleFilterId);
    // getEnvironmentTagCategories(dispatch, UNO_URL, environmentFilterId);
    // getApplicationUsingTagCategory(dispatch, UNO_URL, applicationCategoryId, token);
}